// NOTICE: KAPTION-INTEGRATION
// home-dashboard-app.WEB.6 / WEB.7 — which full-screen dashboard app is the
// user's "home" on this surface. The server resolves it per account and user
// (rules, audiences, permissions) and sends `home_dashboard_apps`
// ({ web, mobile, desktop }, null = Conversations) on every profile
// accounts[] entry and on GET accounts/:id; this file only picks the surface.
import { useKaptionDesktop } from 'dashboard/composables/useKaptionDesktop';

// Rumo Desktop loads this web app, so it is the desktop surface there.
export const currentHomeSurface = () =>
  useKaptionDesktop().isDesktop.value ? 'desktop' : 'web';

export const homeAppIdFrom = (homeDashboardApps, surface) => {
  const id = homeDashboardApps?.[surface ?? currentHomeSurface()];
  return id ? Number(id) : null;
};

export const getUserHomeAppId = (user, accountId, surface) => {
  const account = (user?.accounts || []).find(
    entry => entry.id === Number(accountId)
  );
  return homeAppIdFrom(account?.home_dashboard_apps, surface);
};

// Path (without the /app prefix) a user lands on in an account: the home app
// when one is set for this surface, otherwise the conversation list. The
// conversation route itself is never redirected, so Conversations stays
// reachable.
export const accountLandingPath = (user, accountId, surface) => {
  const appId = getUserHomeAppId(user, accountId, surface);
  return appId
    ? `accounts/${accountId}/dashboard-app/${appId}`
    : `accounts/${accountId}/dashboard`;
};
